import router from './index';

export const DOCUMENT_ORIGIN_ROUTES = {
  Recebido: 'Recebidos',
  EnviadosView: 'Enviados',
  Assinaturasview: 'Assinaturas',
  FavoritoView: 'Favoritos',
  'Todos os documentos view': 'Todos os documentos'
};

export const DEFAULT_DOCUMENT_ORIGIN = 'Todos os documentos';

export function getDocumentOriginRoute (currentRouteName) {
  return DOCUMENT_ORIGIN_ROUTES[currentRouteName] || DEFAULT_DOCUMENT_ORIGIN;
}

export function redirectToDocumentOrigin (currentRouteName, customRouter = null) {
  const targetRoute = getDocumentOriginRoute(currentRouteName);
  const routerInstance = customRouter || router;
  return routerInstance.push({ name: targetRoute });
}
